import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Default from './Default';
import Header from '../layout/Header';

export default class NoScroll extends Default {
  constructor() {
    super();
  }

  beforeShow() {
    //Header.hide();
  }

  afterShow() {
    this._isActive = true;
    document.body.classList.add('__noScroll');
  }

  afterHide() {
    super.afterHide();
    document.body.classList.remove('__noScroll');
  }
}

ControllerPage._addPage('no-scroll', NoScroll);
